// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ActivityPhaseSchema = z.enum(['RECON','DISCOVERY','ANALYSIS','EXPLOITATION'] as const);

export type ActivityPhaseType = `${z.infer<typeof ActivityPhaseSchema>}`

export default ActivityPhaseSchema;
